"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryToQueryString = void 0;
var queryToQueryString = function (query) {
    if (!query)
        return '';
    var keys = Object.keys(query);
    if (!keys.length)
        return '';
    var result = '?';
    keys.forEach(function (key, i) {
        var value = query[key];
        if (Array.isArray(value)) {
            result += "".concat(key, "=").concat(value.join(','));
        }
        else if (value !== null && value !== undefined) {
            result += "".concat(key, "=").concat(value);
        }
        if (i !== keys.length - 1) {
            result += '&';
        }
    });
    return result;
};
exports.queryToQueryString = queryToQueryString;
